import React, { useEffect, useState, useMemo } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  Grid, 
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { motion } from "framer-motion";
import {
  FiAlertCircle,
  FiArrowLeft,
  FiAward,
  FiBook,
  FiBookOpen,
  FiCheck,
  FiCheckCircle,
  FiCheckSquare,
  FiChevronLeft,
  FiChevronRight,
  FiClipboard,
  FiClock,
  FiEdit3,
  FiFileText,
  FiFilter,
  FiHash,
  FiInfo,
  FiLayers,
  FiPlus,
  FiSearch,
  FiTag,
  FiTrendingUp,
  FiX,
} from "react-icons/fi";
import { AiOutlineFileAdd, AiOutlineFilePdf } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import font from "./NotoSansDevanagari-Regular-normal.js";
// import marathiFont from "./NotoSansDevanagari-Regular-normal";
import "jspdf-autotable";
import "./QuestionSetPage.css";
import {
  UI,
  fadeSlideDown,
  pulseIcon,
  sheen,
  rowEnter,
  bounce,
} from "./QuestionSetPageStyling.ts";
import "./QuestionSetPageStyling.ts";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import confetti from "canvas-confetti";
import GolbalVariables from "../../TextConstants.js";

//-------------------------------pdf-lib related Code------------------------------------
import { PDFDocument, rgb } from "pdf-lib";

import Swal from "sweetalert2";


//-------------------------------pdf-lib related Code------------------------------------

const QuestionSetPage = () => {
    const [pdfCount, setPdfCount] = useState('');
    const [exams, setExams] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [topics, setTopics] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [questionSetName, setQuestionSetName] = useState('');
    const [totalMarks, setTotalMarks] = useState('');
    const [passingMarks, setPassingMarks] = useState('');
    const [selectedExam, setSelectedExam] = useState('');
    const [selectedSubject, setSelectedSubject] = useState('');
    //const [selectedTopic, setSelectedTopic] = useState('');
    const [selectedTopic, setSelectedTopic] = useState([]);
    const [questionLimit, setQuestionLimit] = useState('');
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [columnFilters, setColumnFilters] = useState([]);
    const [sorting, setSorting] = useState([]);
    const [duration, setDuration] = useState('');

    const [selectedExamObj, setSelectedExamObj] = useState(null);
    const [selectedSubjectObj, setSelectedSubjectObj] = useState(null);
    const [selectedTopicObj, setSelectedTopicObj] = useState(null);
    const [schoolName, setSchoolName] = useState('New English School Upalavi');
    const [pdfTotalMarks, setPdfTotalMarks] = useState('');
    const [pdfDuration, setPdfDuration] = useState('');
    const [pdfPassingMarks, setPdfPassingMarks] = useState(''); // default value

    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    const passingError = passingMarks && totalMarks && passingMarks > totalMarks;


    const [page, setPage] = useState(0); // current page index
    const rowsPerPage = 10;
    const totalQuestions = questions.length;

    const totalPages = Math.ceil(totalQuestions / rowsPerPage);
    const currentPage = page + 1;
    const [pdfUrl, setPdfUrl] = useState(null);

    // Table state
    const [rowSelection, setRowSelection] = useState({});
    // 
    const [pdfDifficulty, setPdfDifficulty] = useState("");
    const [showQuestionInput, setShowQuestionInput] = useState(true);

    const SortableHeader = ({ column, title }) => (
        <Box
            sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            onClick={column.getToggleSortingHandler()}
        >
            {title}
            {column.getIsSorted() === 'asc' ? ' 🔼' : column.getIsSorted() === 'desc' ? ' 🔽' : ''}
        </Box>
    );


    const columns = useMemo(() => [
        {
            id: 'select',
            header: ({ table }) => (
                <Checkbox
                    checked={table.getIsAllRowsSelected()}
                    onChange={table.getToggleAllRowsSelectedHandler()}
                />
            ),
            cell: ({ row, table }) => {
                const selected = row.getIsSelected();
                const selectedCount = Object.keys(table.getState().rowSelection).length;

                return (
                    <Checkbox
                        checked={selected}
                        onChange={(e) => {
                            if (!selected && questionLimit && selectedCount >= questionLimit) {
                                alert(`You can only select up to ${questionLimit} questions.`);
                                return;
                            }
                            row.getToggleSelectedHandler()(e);
                        }}
                    />
                );
            },
        },
        {
            accessorKey: 'id',
            header: ({ column }) => <SortableHeader column={column} title="Question ID" />,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'question_text',
            header: ({ column }) => <SortableHeader column={column} title="Question" />,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'option_a',
            header: ({ column }) => <SortableHeader column={column} title="Option A" />,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'option_b',
            header: ({ column }) => <SortableHeader column={column} title="Option B" />,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'option_c',
            header: ({ column }) => <SortableHeader column={column} title="Option C" />,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'option_d',
            header: ({ column }) => <SortableHeader column={column} title="Option D" />,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'correct_option',
            header: ({ column }) => <SortableHeader column={column} title="Correct Option" />,
            filterFn: 'includesString',
        },
    ], [questionLimit]);

    const table = useReactTable({
        data: questions,
        columns,
        state: {
            rowSelection,
            columnFilters,
            sorting,
        },
        onRowSelectionChange: (updater) => {
            const newSelection = typeof updater === 'function' ? updater(rowSelection) : updater;
            setRowSelection(newSelection);

            const selectedIds = Object.keys(newSelection)
                .map((rowId) => {
                    const index = parseInt(rowId, 10);
                    const row = table.getRowModel().rows[index];
                    return row?.original?.id;
                })
                .filter(Boolean);

            setSelectedQuestions(selectedIds);
        },
        onColumnFiltersChange: setColumnFilters,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    const pageIndex = table.getState().pagination.pageIndex;
    const pageSize = table.getState().pagination.pageSize;

    const [selectedDifficulty, setSelectedDifficulty] = useState("");

    //fetch exams
    useEffect(() => {
        api.get('/exams')
            .then(res => setExams(res.data))
            .catch(err => console.error('Error fetching exams:', err));
    }, []);

    //fetch subjects
    useEffect(() => {
        if (selectedExam) {
            api.get(`/subjects?exam_id=${selectedExam}`)  // <-- REPLACED
                .then(res => setSubjects(res.data))
                .catch(err => console.error('Error fetching subjects:', err));
        } else {
            setSubjects([]);
        }
    }, [selectedExam]);

    //fetch topics
    useEffect(() => {
        if (selectedSubject) {
            api.get(`/topics?subject_id=${selectedSubject}`)  // <-- REPLACED
                .then(res => setTopics(res.data))
                .catch(err => console.error('Error fetching topics:', err));
        } else {
            setTopics([]);
        }
    }, [selectedSubject]);

    //fetch questions old one working 
    // useEffect(() => {
    //     if (!selectedExam) {
    //         setQuestions([]);
    //         return;
    //     }

    //     setLoading(true);

    //     const params = new URLSearchParams();
    //     params.append('exam_id', selectedExam);
    //     if (selectedSubject) params.append('subject_id', selectedSubject);
    //     if (selectedTopic) params.append('topic_id', selectedTopic);

    //     api.get(`/questions?${params.toString()}`)  // <-- REPLACED
    //         .then(res => {
    //             const formattedQuestions = Array.isArray(res.data)
    //                 ? res.data.map((q) => ({
    //                     ...q,
    //                     id: Number(q.id || q.question_id || q._id),
    //                 }))
    //                 : [];
    //             setQuestions(formattedQuestions);
    //         })
    //         .catch(err => {
    //             console.error('Error fetching questions:', err);
    //             setQuestions([]);
    //         })
    //         .finally(() => setLoading(false));
    // }, [selectedExam, selectedSubject, selectedTopic]);

//use effect for fetching question testing 

    useEffect(() => {
    if (!selectedExam) {
        setQuestions([]);
        return;
    }

    setLoading(true);

    const params = new URLSearchParams();
    params.append("exam_id", selectedExam);

    if (selectedSubject) {
        params.append("subject_id", selectedSubject);
    }

    // ✅ MULTI TOPIC SUPPORT
    if (selectedTopic.length > 0) {
        selectedTopic.forEach((id) => params.append("topic_id[]", id));
    }

    if (pdfDifficulty) {
        params.append("question_level", pdfDifficulty);
    }

    api
        .get(`/questions?${params.toString()}`)
        .then((res) => {
        const formatted = Array.isArray(res.data)
            ? res.data.map((q) => ({
                ...q,
                id: Number(q.id),
            }))
            : [];
        setQuestions(formatted);
        })
        .catch(() => setQuestions([]))
        .finally(() => setLoading(false));
    }, [selectedExam, selectedSubject, selectedTopic, pdfDifficulty]);

    const handleCreateQuestionSet = async () => {
        // Validate input fields (exam required too)
        if (!selectedExam || !questionSetName.trim() || !totalMarks || !passingMarks || selectedQuestions.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Fields',
                text: 'Please fill in all required fields (Exam, Name, Marks, and at least one question).',
            });
            return;
        }

        // Validate numeric fields
        const total = parseInt(totalMarks, 10);
        const passing = parseInt(passingMarks, 10);

        if (isNaN(total) || isNaN(passing) || total <= 0 || passing <= 0 || passing > total) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Marks',
                text: 'Please ensure total and passing marks are valid. Passing marks should not exceed total marks.',
            });
            return;
        }

        setSubmitting(true);

        try {
            Swal.fire({
                title: '🚀 Creating Question Set...',
                html: 'Processing your request... <b></b>',
                timer: 2000,
                timerProgressBar: true,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                    const b = Swal.getHtmlContainer().querySelector('b');
                    let timerInterval = setInterval(() => {
                        b.textContent = `${Swal.getTimerLeft()} ms`;
                    }, 100);
                },
            });

            const payload = {
                exam_id: selectedExam,
                name: questionSetName.trim(),
                total_marks: total,
                passing_marks: passing,
                question_ids: selectedQuestions.map(id => parseInt(id, 10)),
                question_set_type: "manual"
            };

            if (duration) {
                payload.duration_minutes = parseInt(duration, 10);
            }
            if (selectedSubject) {
                payload.subject_id = selectedSubject;
            }
            if (selectedTopic) {
                payload.topic_id = selectedTopic;
            }

            const response = await api.post('/practice-set-questions', payload);
            Swal.close();

            if (response.data?.success) {
                confetti({ particleCount: 150, spread: 70, origin: { y: 0.6 } });
                setTimeout(() => {
                    confetti({ particleCount: 100, spread: 120, origin: { y: 0.8 } });
                }, 500);

                Swal.fire({
                    icon: 'success',
                    title: `🎉 Question Set "${questionSetName}" Created!`,
                    html: `
            <p>Total Marks: <b>${total}</b></p>
            <p>Passing Marks: <b>${passing}</b></p>
            <p>Questions Added: <b>${selectedQuestions.length}</b></p>
        `,
                    showDenyButton: true,
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: "📄 View Sets",
                    denyButtonText: `
        <span style="display:flex; align-items:center; gap:6px; color:white; font-weight:500;">
            <svg xmlns="http://www.w3.org/2000/svg" 
                 fill="white" viewBox="0 0 24 24" width="18" height="18">
                <path d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"/>
            </svg>
            Create Another Set
        </span>
    `,
                    cancelButtonText: "Close",
                    confirmButtonColor: "#28a745",
                    denyButtonColor: "#007bff",
                    backdrop: `
            rgba(0,0,100,0.4)
            url("https://media.giphy.com/media/5GoVLqeAOo6PK/giphy.gif")
            bottom right
            no-repeat
        `,
                }).then((result) => {
                    if (result.isConfirmed) {
                        // 👉 Shortcut: Go to sets list (adjust navigation as needed)
                        navigate("/admin/manage-question-sets");
                    } else if (result.isDenied) {
                        // 👉 Shortcut: Reset form for new creation
                        setQuestionSetName('');
                        setTotalMarks('');
                        setPassingMarks('');
                        setSelectedQuestions([]);
                        setRowSelection({});
                    }
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Failed',
                    text: response.data?.message || 'Something went wrong.',
                });
            }
        } catch (error) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: '❌ Submission Failed',
                text: error.response?.data?.message || error.message || 'An error occurred.',
                footer: '<a href="#">Try again or contact support</a>',
                showCancelButton: true,
                confirmButtonText: "🔄 Retry",
                cancelButtonText: "Close",
            }).then((result) => {
                if (result.isConfirmed) {
                    handleCreateQuestionSet(); // retry
                }
            });
        } finally {
            setSubmitting(false);
        }
    };

    //watermark fuction
    // const addWatermark = (doc, text) => {
    //     const pageCount = doc.internal.getNumberOfPages();
    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     const pageHeight = doc.internal.pageSize.getHeight();

    //     for (let i = 1; i <= pageCount; i++) {
    //         doc.setPage(i);

    //         // Save graphics state for opacity
    //         doc.setGState(new doc.GState({ opacity: 0.1 })); // ✅ set transparency (0.0 = invisible, 1.0 = solid)

    //         // Big bold font
    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(50);

    //         const x = pageWidth / 2;
    //         const y = pageHeight / 2;

    //         // Draw text at center (horizontal + vertical)
    //         doc.setTextColor(100, 100, 100); // subtle gray
    //         doc.text(text, x, y, {
    //             align: 'center',
    //             angle: 30 // diagonal tilt for style
    //         });

    //         // Restore graphics state (so later text is normal)
    //         doc.setGState(new doc.GState({ opacity: 1 }));
    //         doc.setTextColor(0, 0, 0);
    //         doc.setFontSize(12);
    //     }
    // };

    //this function is for watermark text
    const addWatermark = (doc, text) => {
        const pageCount = doc.internal.getNumberOfPages();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);

            // Semi-transparent effect
            doc.setGState(new doc.GState({ opacity: 0.15 }));

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(45);

            const x = pageWidth / 2 + 10;  //shift watermark to right
            const y = pageHeight / 2;

            // Gradient colors (top → bottom)
            const gradientColors = [
                [255, 0, 0],     // red
                [255, 140, 0],   // orange
                [50, 205, 50],   // green
                [30, 144, 255],  // blue
                //[138, 43, 226],  // violet
            ];

            // Draw text multiple times with slightly shifted Y for gradient effect
            gradientColors.forEach((color, idx) => {
                doc.setTextColor(...color);
                doc.text(text, x, y + (idx * 1.2), {
                    align: 'center',
                    baseline: 'middle',
                    angle: 25  //reduced tilt to avopid cutting
                });
            });

            // Restore normal state
            doc.setGState(new doc.GState({ opacity: 1 }));
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(12);
        }
    };

    const loadImage = (url) =>
        new Promise(resolve => {
            if (!url) return resolve(null);
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL('image/png'));
            };
            img.onerror = () => resolve(null);
            img.src = url;
        });

    //function for watermark image
    const addImageWatermark = async (doc, imgUrl) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = imgUrl;
            img.onload = () => {
                const pageCount = doc.internal.getNumberOfPages();
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);

                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();

                    // Set transparency
                    doc.setGState(new doc.GState({ opacity: 0.1 }));

                    // Center watermark
                    const w = pageWidth * 0.6; // width of watermark
                    const h = (img.height / img.width) * w; // maintain aspect ratio
                    const x = (pageWidth - w) / 2;
                    const y = (pageHeight - h) / 2;

                    doc.addImage(img, 'PNG', x, y, w, h);

                    // Reset opacity
                    doc.setGState(new doc.GState({ opacity: 1 }));
                }
                resolve();
            };
            img.onerror = () => resolve(); // ignore if image fails
        });
    };


// Helper to fetch image as bytes
async function fetchImageAsBytes(url) {
  try {
    const res = await fetch(url, { mode: "cors" });
    if (!res.ok) return null;
    const mimeType = res.headers.get("content-type") || "";
    const bytes = await res.arrayBuffer();
    // Verify JPEG header if necessary
    if (mimeType.includes("jpeg") || mimeType.includes("jpg")) {
      const dv = new DataView(bytes);
      if (dv.getUint16(0) !== 0xffd8) {
        console.warn("⚠️ Invalid JPEG (no SOI marker):", url);
        return null;
      }
    }
    return { bytes, mimeType };
  } catch (err) {
    console.warn("⚠️ Failed to load image:", url, err);
    return null;
  }
}


// Helper for wrapping long text lines
// const generateRandomPDF = async () => {
//   const num = Number(pdfCount);

//   if (isNaN(num) || num <= 0) {
//     return Swal.fire({
//       icon: "warning",
//       title: "⚠️ Invalid Count",
//       text: "Please enter a valid number of questions.",
//     });
//   }

//   if (!selectedExam) {
//     return Swal.fire({
//       icon: "warning",
//       title: "🎯 Selection Missing",
//       text: "Please select an exam first.",
//     });
//   }

//   const filtered = questions.filter(
//     (q) =>
//       q.exam_id === parseInt(selectedExam, 10) &&
//       (!selectedSubject || q.subject_id === parseInt(selectedSubject, 10)) &&
//       (!selectedTopic || q.topic_id === parseInt(selectedTopic, 10))
//   );

//   if (filtered.length === 0) {
//     return Swal.fire({
//       icon: "warning",
//       title: "No Questions Found",
//       text: "No questions for this selection.",
//     });
//   }

//   try {
//     Swal.fire({
//       title: "📄 Generating PDF...",
//       html: "Please wait while we prepare your paper.",
//       allowOutsideClick: false,
//       didOpen: () => Swal.showLoading(),
//     });

//     // Shuffle questions
//     const shuffled = [...filtered];
//     for (let i = shuffled.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
//     }
//     const selected = shuffled.slice(0, num);

//     const pdfDoc = await PDFDocument.create();
//     pdfDoc.registerFontkit(fontkit);

//     // Load Marathi font
//     const fontUrl = `${process.env.PUBLIC_URL}/fonts/NotoSansDevanagari-Regular.ttf`;
//     const fontBytes = await fetch(fontUrl).then((r) => r.arrayBuffer());
//     const marathiFont = await pdfDoc.embedFont(fontBytes);

//     // Load left logo
//     const logoUrl = `${process.env.PUBLIC_URL}/logo.png?cacheBust=${Date.now()}`;
//     const logoBytes = await fetch(logoUrl).then((r) => r.arrayBuffer());
//     let leftLogo;
//     try {
//       leftLogo = await pdfDoc.embedPng(logoBytes);
//     } catch {
//       leftLogo = await pdfDoc.embedJpg(logoBytes);
//     }
//     const leftLogoDims = leftLogo.scale(0.08);

//     // Load right logo
//     const rightLogoUrl = `${process.env.PUBLIC_URL}/llogo.png?cacheBust=${Date.now()}`;
//     const rightLogoBytes = await fetch(rightLogoUrl).then((r) => r.arrayBuffer());
//     let rightLogo;
//     try {
//       rightLogo = await pdfDoc.embedPng(rightLogoBytes);
//     } catch {
//       rightLogo = await pdfDoc.embedJpg(rightLogoBytes);
//     }
//     const rightLogoDims = rightLogo.scale(0.08);

//     const pageWidth = 595.28;
//     const pageHeight = 841.89;
//     const margin = 40;

//     // 🔧 Function: Render Marathi text via Canvas for proper shaping
//     async function renderMarathiAsImage(text, size = 9) {
//         const canvas = document.createElement("canvas");
//         const ctx = canvas.getContext("2d");
//         ctx.font = `${size}px "Noto Sans Devanagari", sans-serif`;
//         const textWidth = ctx.measureText(text).width + 20;
//         const textHeight = size + 12;
//         canvas.width = textWidth;
//         canvas.height = textHeight;
//         ctx.fillStyle = "#000";
//         ctx.font = `normal normal 500 ${size}px "Noto Sans Devanagari", sans-serif`;
//         ctx.fillText(text, 5, size);
//         const dataUrl = canvas.toDataURL("image/png");
//         const bytes = await fetch(dataUrl).then((r) => r.arrayBuffer());
//         return await pdfDoc.embedPng(bytes);
//         }
        

//     let page = pdfDoc.addPage([pageWidth, pageHeight]);
//     let y = pageHeight - margin;

//     // ---------- HEADER ---------- 
//     const brandName = "New English School Upalavi";
//     const examTitle = selectedExamObj?.title || "";
//     const subTitle = `${selectedSubjectObj?.name || ""} | ${
//       selectedTopicObj?.title || ""
//     }`;

//     // Left logo
//     page.drawImage(leftLogo, {
//       x: margin,
//       y: y - leftLogoDims.height + 10,
//       width: leftLogoDims.width,
//       height: leftLogoDims.height,
//     });

//     // Right logo
//     page.drawImage(rightLogo, {
//       x: pageWidth - margin - rightLogoDims.width,
//       y: y - rightLogoDims.height + 10,
//       width: rightLogoDims.width,
//       height: rightLogoDims.height,
//     });

//     // Center brand name
//     const brandImg = await renderMarathiAsImage(brandName, 18);
//     page.drawImage(brandImg, {
//       x: pageWidth / 2 - brandImg.width / 2,
//       y: y - 10,
//       width: brandImg.width,
//       height: brandImg.height,
//     });

//     // Subtitle
//     const subtitleImg = await renderMarathiAsImage(`${examTitle} (${subTitle})`, 12);
//     page.drawImage(subtitleImg, {
//       x: pageWidth / 2 - subtitleImg.width / 2,
//       y: y - 35,
//       width: subtitleImg.width,
//       height: subtitleImg.height,
//     });

//     y -= 70;

//     // Student Info
//     const studentImg = await renderMarathiAsImage(
//       "विद्यार्थ्याचे नाव: ______________________   क्रमांक: _______",
//       12
//     );
//     page.drawImage(studentImg, {
//       x: margin,
//       y: y,
//       width: studentImg.width,
//       height: studentImg.height,
//     });
//     y -= 30;

//     // ---------- QUESTIONS ----------
//     for (let i = 0; i < selected.length; i++) {
//   const q = selected[i];
//   const qText = `${i + 1}. ${q.question_text || ""}`;

//   if (y < 120) {
//     page = pdfDoc.addPage([pageWidth, pageHeight]);
//     y = pageHeight - margin - 40;
//   }

//   const qImg = await renderMarathiAsImage(qText, 13);
//   page.drawImage(qImg, { x: margin, y: y, width: qImg.width, height: qImg.height });
//   y -= qImg.height + 10; // 🔹 add consistent space below question

//   const options = ["a", "b", "c", "d"];
//   let xPos = margin + 10;
//   let optionRowHeight = 0;

//   for (let k = 0; k < options.length; k++) {
//     const optKey = options[k];
//     const optText = q[`option_${optKey}`];
//     if (!optText) continue;
//     const optionStr = `⚪ ${String.fromCharCode(65 + k)}) ${optText}`;
//     const optImg = await renderMarathiAsImage(optionStr, 12);
//     page.drawImage(optImg, { x: xPos, y: y, width: optImg.width, height: optImg.height });
//     xPos += optImg.width + 20;

//     optionRowHeight = optImg.height; // track height

//     if (xPos > pageWidth - margin - 100) {
//       y -= optionRowHeight + 8;
//       xPos = margin + 10;
//     }
//   }

//   // 🔹 Extra gap between questions
//   y -= 20;
// }


//     // ---------- FOOTER ----------
//     const pages = pdfDoc.getPages();
//     const totalPages = pages.length;
//     for (let i = 0; i < totalPages; i++) {
//       const p = pages[i];
//       const footerStr = `${brandName} | Page ${i + 1} of ${totalPages}`;
//       const footerImg = await renderMarathiAsImage(footerStr, 10);
//       p.drawImage(footerImg, {
//         x: pageWidth / 2 - footerImg.width / 2,
//         y: 25,
//         width: footerImg.width,
//         height: footerImg.height,
//       });
//     }

//     // ---------- SAVE ----------
//     const pdfBytes = await pdfDoc.save();
//     const blob = new Blob([pdfBytes], { type: "application/pdf" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     const fileName = `${selectedExamObj?.title || "Exam"}_${num}_Questions.pdf`;
//     link.href = url;
//     link.download = fileName.replace(/\s+/g, "_");
//     link.click();

//     Swal.fire({
//       icon: "success",
//       title: "🎉 PDF Ready!",
//       text: `File ${fileName} created successfully.`,
//     });
//   } catch (error) {
//     console.error("❌ PDF Generation Error:", error);
//     Swal.fire({
//       icon: "error",
//       title: "❌ Something went wrong!",
//       text: error.message,
//     });
//   }
// };


const generateRandomPDF = async () => {
  try {
    Swal.fire({
      title: "📄 Generating PDF...",
      html: "Please wait...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const filtered = questions.filter(
      (q) =>
        q.exam_id === parseInt(selectedExam) &&
        (!selectedSubject || q.subject_id === parseInt(selectedSubject)) &&
        (selectedTopic.length === 0 || selectedTopic.includes(q.topic_id))
    );

    if (filtered.length === 0) {
      Swal.close();
      return Swal.fire("⚠️ No Questions", "No matching questions found.", "warning");
    }

    const pdfDoc = await PDFDocument.create();

    // Load logos
    const leftLogoBytes = await fetch(`${process.env.PUBLIC_URL}/logo.png`).then(r =>
      r.arrayBuffer()
    );
    const rightLogoBytes = await fetch(`${process.env.PUBLIC_URL}/llogo.png`).then(r =>
      r.arrayBuffer()
    );

    const leftLogo = await pdfDoc.embedPng(leftLogoBytes);
    const rightLogo = await pdfDoc.embedPng(rightLogoBytes);

    // -------------------------------
    // Helper: text to image (canvas) - keep DPR high for sharpness
    // -------------------------------
    async function textToImgObject({
      text,
      fontSize = 11,
      fontWeight = "500",
      maxWidth = 400,
      leftPadding = 0,
      rightPadding = 0,
      lineMultiplier = 1.1,
    } = {}) {
      const dpr = 4; // higher DPR for sharpness
      const innerWidth = Math.max(10, maxWidth - leftPadding - rightPadding);

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.font = `${fontWeight} ${fontSize * dpr}px "Noto Sans Devanagari"`;
      ctx.textBaseline = "top";

      const words = String(text).split(/\s+/);
      const lines = [];
      let line = "";

      for (let w of words) {
        const test = line ? line + " " + w : w;
        const measured = ctx.measureText(test).width;
        if (measured > innerWidth * dpr && line) {
          lines.push(line);
          line = w;
        } else {
          line = test;
        }
      }
      if (line) lines.push(line);

      const scaledFontSize = fontSize * dpr;
      const scaledLineHeight = Math.ceil(scaledFontSize * lineMultiplier);
      const topPadding = Math.ceil(2 * dpr);
      const bottomPadding = Math.ceil(2 * dpr);

      canvas.width = Math.ceil(maxWidth * dpr);
      canvas.height = Math.ceil(lines.length * scaledLineHeight + topPadding + bottomPadding);

      ctx.font = `${fontWeight} ${scaledFontSize}px "Noto Sans Devanagari"`;
      ctx.textBaseline = "top";
      ctx.fillStyle = "#000";

      let y = topPadding;
      const x = Math.round(leftPadding * dpr);
      for (const ln of lines) {
        ctx.fillText(ln, x, y);
        y += scaledLineHeight;
      }

      const dataUrl = canvas.toDataURL();
      const bytes = await fetch(dataUrl).then(r => r.arrayBuffer());
      const img = await pdfDoc.embedPng(bytes);

      return { img, w: maxWidth, h: canvas.height / dpr, leftPadding, innerWidth };
    }

    // -------------------------------
    // Page setup
    // -------------------------------
    const pageWidth = 595;
    const pageHeight = 842;
    const margin = 58;

    let page = pdfDoc.addPage([pageWidth, pageHeight]);
    let y = pageHeight - margin;

    // -------------------------------
    // Header logos
    // -------------------------------
    const logoScale = 0.05;
    const leftDims = leftLogo.scale(logoScale);
    const rightDims = rightLogo.scale(logoScale);

    page.drawImage(leftLogo, {
  x: margin - 14,
  y: y - leftDims.height + 10,
  width: leftDims.width,
  height: leftDims.height,
});

   page.drawImage(rightLogo, {
  x: pageWidth - margin - rightDims.width + 16,
  y: y - rightDims.height + 10,
  width: rightDims.width,
  height: rightDims.height,
});

    // -------------------------------
    // Title
    // -------------------------------
    const titleObj = await textToImgObject({
      text: "New English School Upalavi",
      fontSize: 12,
      fontWeight: "600",
      maxWidth: 420,
      lineMultiplier: 1.05,
    });
    page.drawImage(titleObj.img, {
      x: pageWidth / 2 - titleObj.w / 2,
      y,
      width: titleObj.w,
      height: titleObj.h,
    });
    y -= titleObj.h + 4;

    // Subtitle
    const subtitle = [selectedExamObj?.title, selectedSubjectObj?.name, selectedTopicObj?.title]
      .filter(Boolean)
      .join("   ");
    if (subtitle) {
      const subObj = await textToImgObject({
        text: subtitle,
        fontSize: 10,
        fontWeight: "500",
        maxWidth: 420,
        lineMultiplier: 1.06,
      });
      page.drawImage(subObj.img, {
        x: pageWidth / 2 - subObj.w / 2,
        y,
        width: subObj.w,
        height: subObj.h,
      });
      y -= subObj.h + 8;
    }

    // Student info row
    const infoObj = await textToImgObject({
      text: "विद्यार्थ्याचे नाव: ______________________________    क्रमांक: ____    गुण: ___ / ___",
      fontSize: 10,
      fontWeight: "500",
      maxWidth: 480,
      lineMultiplier: 1.05,
    });
    page.drawImage(infoObj.img, { x: margin - 6, y, width: infoObj.w, height: infoObj.h });
    y -= infoObj.h + 8;

    // -------------------------------
    // QUESTION BLOCKS WITH WRAPPED OPTIONS
    // -------------------------------
    const questionMaxWidth = pageWidth - margin * 2 + 30;
    const questionLeftX = margin - 12;
    const optionStartX = margin - 12;
    const optionSpacing = 5;

    const shuffled = [...filtered].sort(() => Math.random() - 0.5);
    const selectedQ = shuffled.slice(0, pdfCount);

    for (let i = 0; i < selectedQ.length; i++) {
      const q = selectedQ[i];

      if (y < 120) {
        page = pdfDoc.addPage([pageWidth, pageHeight]);
        y = pageHeight - margin;
      }

      y -= 12;

      const qObj = await textToImgObject({
        text: `${i + 1}) ${q.question_text}`,
        fontSize: 9,
        fontWeight: "400",
        maxWidth: questionMaxWidth,
        lineMultiplier: 1.16,
      });
      page.drawImage(qObj.img, { x: questionLeftX, y, width: qObj.w, height: qObj.h });
      y -= qObj.h + 6;

      const opts = [
        { key: "A", text: q.option_a },
        { key: "B", text: q.option_b },
        { key: "C", text: q.option_c },
        { key: "D", text: q.option_d },
      ];

      let optionX = optionStartX;
      let optionY = y;
      let lineHeight = 0;
      const maxLineWidth = pageWidth - margin * 2;

      for (const opt of opts) {
        const optObj = await textToImgObject({
          text: `${opt.key}) ${opt.text}`,
          fontSize: 9,
          fontWeight: "400",
          maxWidth: maxLineWidth / 2 - optionSpacing,
          lineMultiplier: 1.16,
        });

        if (optionX + optObj.w > pageWidth - margin) {
          optionX = optionStartX;
          optionY -= lineHeight + 4;
          lineHeight = 0;
        }

        page.drawImage(optObj.img, { x: optionX, y: optionY, width: optObj.w, height: optObj.h });
        optionX += optObj.w + optionSpacing;
        lineHeight = Math.max(lineHeight, optObj.h);
      }

      y = optionY - lineHeight - 8;
    }

    // -------------------------------
    // SAVE PDF
    // -------------------------------
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Question_Paper.pdf";
    link.click();

    Swal.fire("✔ Done", "PDF generated successfully!", "success");
  } catch (error) {
    Swal.fire("❌ Error", error.message || String(error), "error");
    console.error(error);
  }
};


// Apply Filters function
    const applyFilters = () => {
        let filtered = questions;

        if (selectedExamObj) {
            filtered = filtered.filter((q) => q.exam_id === selectedExamObj.id);
        }
        if (selectedSubjectObj) {
            filtered = filtered.filter((q) => q.subject_id === selectedSubjectObj.id);
        }
        if (selectedTopicObj) {
            filtered = filtered.filter((q) => q.topic_id === selectedTopicObj.id);
        }
        if (questionLimit) {
            filtered = filtered.slice(0, questionLimit);
        }

        setSelectedQuestions(filtered);

        toast.success(`Filters applied! Showing ${filtered.length} questions.`, {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
        });
    };

    // Clear Filters function
    const clearFilters = () => {
        setSelectedExam("");
        setSelectedSubject("");
       // setSelectedTopic("");
        setSelectedTopic([])
        setQuestionLimit("");
        setSelectedExamObj(null);
        setSelectedSubjectObj(null);
        setSelectedTopicObj(null);
        setSelectedQuestions(questions); // reset to full list
    };

    return (
        <Box p={2}>
            {/* 🔷 Header Placeholder */}
            <Box
                mb={3}
                display="flex"
                flexDirection={isSmall ? 'column' : 'row'}
                justifyContent="space-between"
                alignItems="center"
                gap={2}
                textAlign={isSmall ? 'center' : 'left'}
                //this sx code is for background of header
                sx={{
                    background: 'linear-gradient(90deg, #f8fbff, #e3f2fd)',
                    borderRadius: '12px',
                    padding: '16px 24px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                    animation: 'fadeSlideDown 0.6s ease-out',
                }}
            >
                <IconButton
                    onClick={() => navigate(-1)}
                    sx={{
                        borderRadius: '12px',
                        p: '8px 12px',
                        background: 'linear-gradient(135deg, #00bcd4, #007bff)',
                        color: '#fff',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #007bff, #00bcd4)',
                            transform: 'scale(1.05)',
                            boxShadow: '0 5px 12px rgba(0, 123, 255, 0.4)',
                        },
                        transition: 'all 0.25s ease',
                    }}
                >
                    <FiArrowLeft />
                    {!isSmall && <Typography variant="button" sx={{ ml: 1, fontWeight: 600 }}>Back</Typography>}
                </IconButton>

                <Box display="flex" alignItems="center"
                    justifyContent="center" gap={1} flex={1}>
                    <Box sx={{
                        fontSize: '2rem',
                        background: '#e3f2fd',
                        borderRadius: '50%',
                        p: 1,
                        color: '#1976d2',
                        animation: 'pulseIcon 1.6s infinite',
                    }}>
                        <FiCheckSquare />
                    </Box>
                    <Typography
                        variant={isSmall ? 'h6' : 'h5'}
                        sx={{
                            fontWeight: 'bold',
                            background: 'linear-gradient(90deg, #007BFF, #00d4ff)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            textTransform: 'uppercase',
                            letterSpacing: '1.2px',
                            px: 1,
                            animation: 'fadeIn 1s ease-in',
                        }}
                    >
                        Create Questions Set
                    </Typography>
                </Box>
            </Box>



            {/* code for dropdwon section of exam subject and topic and no.of questions */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <Paper
                    elevation={4}
                    sx={{
                        p: 2,
                        mb: 3,
                        borderRadius: 3,
                        background: "#fff",
                        boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05), 0 8px 24px rgba(0,0,0,0.08)",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                >
                   
                   <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
>
    <Paper
        elevation={4}
        sx={{
            p: 2,
            mb: 3,
            borderRadius: 3,
            background: "#fff",
            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05), 0 8px 24px rgba(0,0,0,0.08)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
        }}
    >
        <AccordionDetails sx={{ px: 2, py: 3 }}>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "1fr 1fr",
                        md: "1fr 1fr 1fr",
                    },
                    gap: 3,
                }}
            >

                {/* Exam */}
                <TextField
                    select
                    fullWidth
                    size="small"
                    label="Select Exam (Required)"
                    value={selectedExam}
                    onChange={(e) => {
                        const id = e.target.value;
                        setSelectedExam(id);
                        setSelectedSubject("");
                        setSelectedTopic([]);
                        const ex = exams.find((x) => x.id === id);
                        setSelectedExamObj(ex || null);
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <FiLayers style={{ color: "#1976d2" }} />
                            </InputAdornment>
                        ),
                    }}
                >
                    <MenuItem value="">None</MenuItem>
                    {exams.map((ex) => (
                        <MenuItem key={ex.id} value={ex.id}>
                            {ex.title}
                        </MenuItem>
                    ))}
                </TextField>

                {/* Subject */}
                <TextField
                    select
                    fullWidth
                    size="small"
                    label="Select Subject"
                    value={selectedSubject}
                    onChange={(e) => {
                        setSelectedSubject(e.target.value);
                        setSelectedSubjectObj(
                            subjects.find((s) => s.id === e.target.value) || null
                        );
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <FiBook style={{ color: "#1976d2" }} />
                            </InputAdornment>
                        ),
                    }}
                >
                    <MenuItem value="">None</MenuItem>
                    {subjects.map((s) => (
                        <MenuItem key={s.id} value={s.id}>
                            {s.name}
                        </MenuItem>
                    ))}
                </TextField>

                {/* Topics */}
                <TextField
                    select
                    fullWidth
                    size="small"
                    label="Select Topic(s)"
                    value={selectedTopic}
                    SelectProps={{
                        multiple: true,
                        renderValue: (selected) =>
                            selected.map((id) => topics.find((t) => t.id === id)?.title).join(", "),
                    }}
                    onChange={(e) => {
                        setSelectedTopic(e.target.value);
                    }}
                >
                    {topics.map((t) => (
                        <MenuItem key={t.id} value={t.id}>
                            <Checkbox checked={selectedTopic.includes(t.id)} />
                            {t.title}
                        </MenuItem>
                    ))}
                </TextField>

                {/* Difficulty */}
                <FormControl fullWidth size="small">
                    <InputLabel>Difficulty Level</InputLabel>
                    <Select
                        value={pdfDifficulty}
                        label="Difficulty Level"
                        onChange={(e) => setPdfDifficulty(e.target.value)}
                        startAdornment={
                            <InputAdornment position="start">
                                <FiTrendingUp style={{ color: "#1976d2" }} />
                            </InputAdornment>
                        }
                    >
                        <MenuItem value="">All Levels</MenuItem>
                        <MenuItem value="easy">Easy</MenuItem>
                        <MenuItem value="medium">Medium</MenuItem>
                        <MenuItem value="hard">Hard</MenuItem>
                    </Select>
                </FormControl>

                {/* NO. OF QUESTIONS (Hidden but Working) */}
                <TextField
                    type="number"
                    fullWidth
                    size="small"
                    label="No. of Questions"
                    value={questionLimit}
                    onChange={(e) => {
                        const v = parseInt(e.target.value);
                        setQuestionLimit(isNaN(v) ? 0 : v);
                    }}
                    sx={{
                        display: "none", // HIDDEN — NOT REMOVED
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <FiHash style={{ color: "#1976d2" }} />
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
        </AccordionDetails>

        {/* STICKY BUTTONS (RIGHT ALIGNED) */}
        <Box
            sx={{
                width: "100%",             // FIX
                display: "flex",
                justifyContent: "flex-end", // ALWAYS RIGHT
                alignItems: "center",
                gap: 2,
                mt: 2,
                position: "sticky",
                bottom: 0,
                zIndex: 10,
                backdropFilter: "blur(10px)",
                background: "rgba(255, 255, 255, 0.8)",
                p: 2,
                borderTop: "1px solid rgba(255,255,255,0.3)",
                boxShadow: "0 -4px 20px rgba(0,0,0,0.08)",
                borderRadius: "0 0 12px 12px",
            }}
        >
            {/* Clear Filters */}
            <Tooltip title="Clear all selected filters" arrow>
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                    <Button
                        variant="outlined"
                        startIcon={<FiX />}
                        onClick={clearFilters}
                        sx={{
                            borderRadius: 2,
                            borderColor: "#1976d2",
                            color: "#1976d2",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            "&:hover": {
                                backgroundColor: "rgba(25,118,210,0.08)",
                                borderColor: "#1976d2",
                            },
                        }}
                    >
                        Clear Filters
                    </Button>
                </motion.div>
            </Tooltip>

            {/* Apply Filters */}
            <Tooltip title="Apply selected filters" arrow>
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                    <Button
                        variant="contained"
                        startIcon={<FiCheck />}
                        onClick={applyFilters}
                        sx={{
                            borderRadius: 2,
                            background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            boxShadow: "0 4px 14px rgba(25, 118, 210, 0.4)",
                            "&:hover": {
                                background: "linear-gradient(90deg, #1565c0, #2196f3)",
                                transform: "translateY(-2px)",
                                boxShadow: "0 6px 18px rgba(25, 118, 210, 0.6)",
                            },
                        }}
                    >
                        Apply Filters
                    </Button>
                </motion.div>
            </Tooltip>
        </Box>
    </Paper>
</motion.div>

                </Paper>
            </motion.div>

            {/* Toast container */}
            {/* <ToastContainer /> */}
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar
                closeOnClick
                pauseOnHover
                draggable
                toastStyle={{
                    background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                    color: "#fff",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                }}
            />



            {/* adding input field and generate pdf button */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <Paper
                    elevation={4}
                    sx={{
                        p: 3,
                        mb: 3,
                        borderRadius: 3,
                        background: "#fff",
                        boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05), 0 8px 24px rgba(0,0,0,0.08)",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        "&:hover": {
                            transform: "translateY(-2px) scale(1.01)",
                            boxShadow: "0 16px 36px rgba(0,0,0,0.15)"
                        }
                    }}
                >
                    {/* Heading */}
                    <Box display="flex" alignItems="center" mb={4}>
                        <motion.div whileHover={{ rotate: 15, scale: 1.1 }}>
                            <AiOutlineFilePdf style={{ fontSize: 28, color: "#1976d2", marginRight: 8 }} />
                        </motion.div>
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: "bold", color: "#1976d2", position: "relative" }}
                        >
                            PDF Settings
                        </Typography>
                    </Box>
                    <Typography variant="subtitle2" color="textSecondary" mb={3}>
                        Enter details to generate your PDF question set.
                    </Typography>
                    <Divider sx={{ mb: 3 }} />

                    {/* Form Fields */}
                    <Grid container spacing={2} alignItems="stretch">
  <Grid item xs={12} md={3} sm={6}>
    <TextField
      variant="outlined"
      fullWidth
      label={
        <span>
          Questions Count <span style={{ color: 'red' }}>*</span>
        </span>
      }
      type="number"
      value={pdfCount}
      onChange={(e) => setPdfCount(e.target.value)}
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FiHash color="#1976d2" />
          </InputAdornment>
        ),
        sx: { borderRadius: 2, backgroundColor: "#fafafa" }
      }}
      sx={{
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#1976d2",
          boxShadow: "0 0 6px rgba(25, 118, 210, 0.3)"
        }
      }}
    />
  </Grid>

  <Grid item xs={12} md={3} sm={6}>
    <TextField
      variant="outlined"
      fullWidth
      label={<span>Total Marks <span style={{ color: 'red' }}>*</span></span>}
      type="number"
      value={pdfTotalMarks}
      onChange={(e) => setPdfTotalMarks(e.target.value)}
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FiAward color="#1976d2" />
          </InputAdornment>
        ),
        sx: { borderRadius: 2, backgroundColor: "#fafafa" }
      }}
      sx={{
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#1976d2",
          boxShadow: "0 0 6px rgba(25, 118, 210, 0.3)"
        }
      }}
    />
  </Grid>

  <Grid item xs={12} md={3} sm={6}>
    <TextField
      variant="outlined"
      fullWidth
      label={<span>Passing Marks <span style={{ color: 'red' }}>*</span></span>}
      type="number"
      value={pdfPassingMarks}
      onChange={(e) => setPdfPassingMarks(e.target.value)}
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FiCheckCircle color="#1976d2" />
          </InputAdornment>
        ),
        sx: { borderRadius: 2, backgroundColor: "#fafafa" }
      }}
      sx={{
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#1976d2",
          boxShadow: "0 0 6px rgba(25, 118, 210, 0.3)"
        }
      }}
    />
  </Grid>

  <Grid item xs={12} md={3} sm={6}>
    <TextField
      variant="outlined"
      fullWidth
      label={<span>Duration (mins) <span style={{ color: 'red' }}>*</span></span>}
      type="number"
      value={pdfDuration}
      onChange={(e) => setPdfDuration(e.target.value)}
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FiClock color="#1976d2" />
          </InputAdornment>
        ),
        sx: { borderRadius: 2, backgroundColor: "#fafafa" }
      }}
      sx={{
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#1976d2",
          boxShadow: "0 0 6px rgba(25, 118, 210, 0.3)"
        }
      }}
    />
  </Grid>

  {/* 🔽 New Dropdown for Difficulty Level */}
 

  <Grid item xs={12} md="auto" sm={6}>
    <Tooltip title="Create a random set & export PDF" arrow>
      <Button
        startIcon={<AiOutlineFilePdf />}
        variant="contained"
        onClick={generateRandomPDF}
        sx={{
          height: 40,
          px: 3,
          borderRadius: 2,
          background: "linear-gradient(90deg, #1976d2, #42a5f5)",
          textTransform: "uppercase",
          fontWeight: "bold",
          boxShadow: "0 4px 14px rgba(25, 118, 210, 0.4)",
          transition: "0.3s",
          "&:hover": {
            background: "linear-gradient(90deg, #1565c0, #2196f3)",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 18px rgba(25, 118, 210, 0.6)"
          }
        }}
      >
        Generate PDF
      </Button>
    </Tooltip>
  </Grid>
</Grid>


                </Paper>
            </motion.div>



            {/* 📋 Question Table */}
            <Paper elevation={4} sx={{ p: 2, mb: 3 }}>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <Paper
                        elevation={4}
                        sx={{
                            p: 2,
                            mb: 3,
                            borderRadius: 3,
                            background: "#fff",
                            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05), 0 8px 24px rgba(0,0,0,0.08)",
                            transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        }}
                    >
                        <Box display="flex" alignItems="center" gap={2}>
                            <motion.div whileHover={{ rotate: 15, scale: 1.1 }} whileTap={{ scale: 0.95 }}>
                                <FiFileText style={{ fontSize: 28, color: "#1976d2" }} />
                            </motion.div>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: "bold",
                                    background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    letterSpacing: 0.5,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                Questions Table
                            </Typography>

                            {/* Optional: show total questions like a badge */}
                            <Chip
                                label={`${table.getFilteredRowModel().rows.length} Questions`}
                                color="primary"
                                size="small"
                                sx={{ fontWeight: 600 }}
                            />
                        </Box>
                    </Paper>
                </motion.div>


                <Paper elevation={3}>
                    {loading ? (
                        <Box p={3} display="flex" justifyContent="center">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box>
                            <TableContainer
                                sx={{
                                    maxHeight: 520,
                                    borderRadius: 2,
                                    overflow: "auto",
                                    '& tbody tr': {
                                        animation: `${rowEnter} .25s ease`,
                                        transition: 'transform .12s ease, box-shadow .12s ease',
                                        backgroundColor: 'rgba(100,181,246,0.1)', // subtle blue highlight
                                    },
                                    '& tbody tr:hover': {
                                        transform: 'scale(1.005)',
                                        boxShadow: '0 6px 14px rgba(0,0,0,.08)',
                                    },
                                    '& tbody tr:nth-of-type(even)': { backgroundColor: 'rgba(25,118,210,0.025)' },
                                }}>

                                <Table stickyHeader>
                                    <TableHead>
                                        {table.getHeaderGroups().map(headerGroup => (
                                            <TableRow key={headerGroup.id} className="table-row-fade">
                                                {headerGroup.headers.map(header => (
                                                    <TableCell key={header.id} sx={{
                                                        background: 'linear-gradient(90deg, #64b5f6 0%, #bbdefb 100%)',
                                                        color: '#fff',
                                                        fontWeight: 700,
                                                    }}>
                                                        {flexRender(header.column.columnDef.header, header.getContext())}

                                                        {header.column.getCanFilter() && (
                                                            <TextField
                                                                size="small"
                                                                variant="outlined"
                                                                placeholder="Filter..."
                                                                value={header.column.getFilterValue() ?? ''}
                                                                onChange={(e) => header.column.setFilterValue(e.target.value)}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <FiSearch style={{ color: '#1976d2' }} />
                                                                        </InputAdornment>
                                                                    ),
                                                                    sx: { borderRadius: 2, backgroundColor: '#f9f9f9' },
                                                                }}
                                                                sx={{
                                                                    mt: 1,
                                                                    minWidth: 160,
                                                                    '& .MuiOutlinedInput-root': {
                                                                        borderRadius: 2,
                                                                        '& fieldset': { borderColor: 'rgba(25,118,210,0.3)' },
                                                                        '&:hover fieldset': { borderColor: '#1976d2' },
                                                                        '&.Mui-focused fieldset': { borderColor: '#1976d2' },
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableHead>


                                    <TableBody>
                                        {table.getRowModel().rows.length === 0 ? (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={table.getVisibleFlatColumns().length}
                                                    align="center"
                                                    sx={{ py: 5 }}
                                                >
                                                    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                                                        <FiAlertCircle size={32} style={{ marginBottom: 4 }} />
                                                        <Typography variant="h6" fontWeight={700}>
                                                            No questions match your filters
                                                        </Typography>
                                                        <Typography variant="body2" color="text.secondary">
                                                            Try adjusting filters or question limit.
                                                        </Typography>
                                                        <Button
                                                            size="small"
                                                            //   variant="contained"
                                                            onClick={() => {
                                                                setSelectedSubject('');
                                                                //setSelectedTopic('');
                                                                setSelectedTopic([]);
                                                            }}
                                                        >
                                                            Clear Filters
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            table.getRowModel().rows.map((row) => (
                                                <TableRow key={row.id} hover className="table-row-fade">
                                                    {row.getVisibleCells().map((cell) => (
                                                        <TableCell key={cell.id}>
                                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>

                                    <TableFooter
                                        sx={{
                                            position: "sticky",
                                            bottom: 0,
                                            zIndex: 2,
                                            background: "linear-gradient(90deg, #e3f2fd 0%, #bbdefb 100%)",
                                            borderTop: "2px solid #90caf9",
                                            boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
                                        }}
                                    >
                                        <TableRow>
                                            <TableCell
                                                colSpan={table.getVisibleFlatColumns().length}
                                                align="center"
                                                sx={{
                                                    fontWeight: 600,
                                                    color: "#0d47a1",
                                                    fontSize: "0.95rem",
                                                    letterSpacing: 0.5,
                                                }}
                                            >
                                                📊 Page {table.getState().pagination.pageIndex + 1} of{" "}
                                                {table.getPageCount()} — Showing {table.getState().pagination.pageSize} out of{" "}
                                                {table.getFilteredRowModel().rows.length} questions
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>

                            {/* <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
                                <Select
                                    size="small"
                                    value={pageSize}
                                    onChange={(e) => table.setPageSize(Number(e.target.value))}
                                >
                                    {[5, 10, 20].map(size => (
                                        <MenuItem key={size} value={size}>
                                            Show {size}
                                        </MenuItem>
                                    ))}
                                </Select>

                                <TablePagination
                                    component="div"
                                    count={table.getFilteredRowModel().rows.length}
                                    page={pageIndex}
                                    onPageChange={(_, newPage) => table.setPageIndex(newPage)}
                                    rowsPerPage={pageSize}
                                    rowsPerPageOptions={[]}
                                />
                            </Box> */}
                            <Stack direction="row" justifyContent="space-between"
                                alignItems="center" p={2} sx={{
                                    background: 'rgba(250,250,250,0.9)',
                                    borderTop: '1px solid rgba(0,0,0,0.05)',
                                    borderRadius: '0 0 12px 12px',
                                }}>
                                <Typography variant="body2" color="text.secondary">
                                    {table.getFilteredRowModel().rows.length} results
                                </Typography>

                                <Stack direction="row" alignItems="center" gap={1}>
                                    <Select size="small" value={pageSize} onChange={(e) => table.setPageSize(Number(e.target.value))}>
                                        {[5, 10, 20].map(size => <MenuItem key={size} value={size}>Show {size}</MenuItem>)}
                                    </Select>

                                    <IconButton disabled={!table.getCanPreviousPage()} onClick={() => table.previousPage()}><FiChevronLeft /></IconButton>
                                    <Typography variant="body2">
                                        Page {pageIndex + 1} / {Math.max(1, table.getPageCount?.() || 1)}
                                    </Typography>
                                    <IconButton disabled={!table.getCanNextPage()} onClick={() => table.nextPage()}><FiChevronRight /></IconButton>
                                </Stack>
                            </Stack>

                        </Box>
                    )}
                </Paper>
            </Paper>




            {/* final section of question set details */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                display="none" 
            >
                <Paper
                    elevation={4}
                    sx={{
                        p: 3,
                        mb: 3,
                        borderRadius: 3,
                        //   background: "linear-gradient(145deg, #f9f9f9, #ffffff)",
                        background: "#fff",
                        //   boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                        boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05), 0 8px 24px rgba(0,0,0,0.08)",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        "&:hover": {
                            transform: "translateY(-2px) scale(1.01)",
                            boxShadow: "0 16px 36px rgba(0,0,0,0.15)"
                        }
                    }}
                >
                    {/* Heading */}
                    <Box display="none" alignItems="center" mb={4}>
                        <motion.div whileHover={{ rotate: 15, scale: 1.1 }}>
                            <FiBookOpen style={{ fontSize: 28, color: "#1976d2", marginRight: 8 }} />
                        </motion.div>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: "bold",
                                color: "#1976d2",
                                position: "relative",
                            }}
                        >
                            Question Set Details
                        </Typography>
                    </Box>
                    <Typography variant="subtitle2" color="textSecondary" mb={3}  display="none" >
                        Enter details to create a new question set.
                    </Typography>
                    <Divider sx={{ mb: 3 }}  display="none"  />


                    {/* Form Fields */}
                    <Grid container spacing={2} alignItems="stretch"  display="none" >
                        {/* Question Set Name */}
                        <Grid item xs={12} md={3} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label={<span>Question Set Name <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter name"
                                value={questionSetName}
                                onChange={(e) => setQuestionSetName(e.target.value)}
                                size="small"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <FiEdit3 color="#1976d2" />
                                        </InputAdornment>
                                    ),
                                    sx: { borderRadius: 2, backgroundColor: "#fafafa" }
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                        borderColor: "#1976d2",
                                        boxShadow: "0 0 6px rgba(25, 118, 210, 0.3)"
                                    }
                                }}
                            />
                            <Typography variant="caption" color="textSecondary">
                                {questionSetName.length}/50 characters
                            </Typography>
                        </Grid>

                        {/* Total Marks */}
                        <Grid item xs={12} md={3} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label={<span>Total Marks <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter total marks"
                                type="number"
                                value={totalMarks}
                                onChange={(e) => setTotalMarks(e.target.value)}
                                size="small"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <FiAward color="#1976d2" />
                                        </InputAdornment>
                                    ),
                                    sx: { borderRadius: 2, backgroundColor: "#fafafa" }
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                        borderColor: "#1976d2",
                                        boxShadow: "0 0 6px rgba(25, 118, 210, 0.3)"
                                    }
                                }}
                            />
                        </Grid>

                        {/* Passing Marks */}
                        <Grid item xs={12} md={3} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label={<span>Passing Marks <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter passing marks"
                                type="number"
                                value={passingMarks}
                                onChange={(e) => setPassingMarks(e.target.value)}
                                size="small"
                                error={passingError}
                                helperText={passingError ? "Passing marks cannot exceed total marks" : ""}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <FiCheckCircle color="#1976d2" />
                                        </InputAdornment>
                                    ),
                                    sx: { borderRadius: 2, backgroundColor: "#fafafa" }
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                        borderColor: "#1976d2",
                                        boxShadow: "0 0 6px rgba(25, 118, 210, 0.3)"
                                    }
                                }}
                            />
                        </Grid>

                        {/* Duration */}
                        <Grid item xs={12} md={3} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Duration (minutes)"
                                placeholder="Enter duration"
                                type="number"
                                value={duration}
                                onChange={(e) => setDuration(e.target.value)}
                                size="small"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <FiClock color="#1976d2" />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title="Duration of the exam in minutes">
                                                <FiInfo color="#1976d2" />
                                            </Tooltip>
                                        </InputAdornment>
                                    ),
                                    sx: { borderRadius: 2, backgroundColor: "#fafafa" }
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                        borderColor: "#1976d2",
                                        boxShadow: "0 0 6px rgba(25, 118, 210, 0.3)"
                                    }
                                }}
                            />
                        </Grid>

                        {/* Submit Button */}
                        <Grid item xs={12} md="auto" sm={6}>
                            <Tooltip title="Save and create a new question set" arrow>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    onClick={handleCreateQuestionSet}
                                    startIcon={<AiOutlineFileAdd />}
                                    // startIcon={
                                    //     submitting ? (
                                    //         <CircularProgress size={18} color="inherit" />
                                    //     ) : null
                                    // }
                                    sx={{
                                        height: 40,
                                        px: 3,
                                        borderRadius: 2,
                                        background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                                        textTransform: "uppercase",
                                        fontWeight: "bold",
                                        boxShadow: "0 4px 14px rgba(25, 118, 210, 0.4)",
                                        transition: "0.3s",
                                        "&:hover": {
                                            background: "linear-gradient(90deg, #1565c0, #2196f3)",
                                            transform: "translateY(-2px)",
                                            boxShadow: "0 6px 18px rgba(25, 118, 210, 0.6)"
                                        }
                                    }}
                                >
                                    {submitting ? "Submitting..." : "Create Questions Set"}
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Paper>
            </motion.div>





        </Box>
    );
};

export default QuestionSetPage;
